import { Route, Switch } from 'react-router-dom';
import React, { Suspense } from 'react';
import { Loader } from 'src/redesign/components/Loader';

const LoginPage = React.lazy(() =>
  import('src/redesign/pages/Login').then((module) => ({ default: module.Login })),
);

const AttendeeLoginPage = React.lazy(() =>
  import('src/redesign/pages/Login/AttendeeLogin').then((module) => ({
    default: module.AttendeeLogin,
  })),
);

const SignupPage = React.lazy(() =>
  import('src/modules/signup').then((module) => ({ default: module.Signup })),
);

const CreateEventPublicPage = React.lazy(() =>
  import('src/redesign/pages/CreateEventPage').then((module) => ({
    default: module.CreateEventPublic,
  })),
);

const RequestResetPasswordPage = React.lazy(() =>
  import('src/modules/reset-password').then((module) => ({ default: module.RequestResetPassword })),
);

const ResetPasswordPage = React.lazy(() =>
  import('src/modules/reset-password').then((module) => ({ default: module.ResetPassword })),
);

const CheckYourEmailPage = React.lazy(() =>
  import('src/modules/reset-password').then((module) => ({ default: module.CheckYourEmail })),
);

const EmailVerificationPage = React.lazy(() =>
  import('src/modules/email-verification').then((module) => ({
    default: module.EmailVerification,
  })),
);

const ResetPasswordConfirmPage = React.lazy(() =>
  import('src/modules/reset-password').then((module) => ({ default: module.ResetPasswordConfirm })),
);

const WixLoginProxyPage = React.lazy(() =>
  import('src/modules/login/wix-login-proxy').then((module) => ({
    default: module.WixLoginProxy,
  })),
);

const WixPricingPage = React.lazy(() =>
  import('src/modules/sites/wix-pricing').then((module) => ({ default: module.WixPricing })),
);

const SelfCheckinKioskPage = React.lazy(() =>
  import('src/redesign/pages/SelfCheckinKioskPage').then((module) => ({
    default: module.SelfCheckinKioskPage,
  })),
);

const AttendeeTicketDetailsPage = React.lazy(() =>
  import('src/redesign/pages/AttendeeTicketDetailsPage').then((module) => ({
    default: module.AttendeeTicketDetailsPage,
  })),
);

const AcceptInvitationPage = React.lazy(() =>
  import('src/redesign/pages/AcceptInvitationPage').then((module) => ({
    default: module.AcceptInvitationPage,
  })),
);

const InvitationsPage = React.lazy(() =>
  import('src/redesign/pages/InvitationsPage').then((module) => ({
    default: module.InvitationsPage,
  })),
);

export const PublicRouter = () => {
  return (
    <Switch>
      <Route
        exact
        path="/auth/wix-login-proxy"
        component={() => (
          <Suspense fallback={<Loader />}>
            <WixLoginProxyPage />
          </Suspense>
        )}
      />

      <Route
        exact
        path="/auth/login"
        component={() => (
          <Suspense fallback={<Loader />}>
            <LoginPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/auth/attendee/login"
        component={() => (
          <Suspense fallback={<Loader />}>
            <AttendeeLoginPage />
          </Suspense>
        )}
      />
      <Route
        path="/auth/signup"
        component={() => (
          <Suspense fallback={<Loader />}>
            <SignupPage />
          </Suspense>
        )}
      />
      <Route
        path="/auth/request-reset-password"
        component={() => (
          <Suspense fallback={<Loader />}>
            <RequestResetPasswordPage />
          </Suspense>
        )}
      />
      <Route
        path="/auth/reset-password"
        component={() => (
          <Suspense fallback={<Loader />}>
            <ResetPasswordPage />
          </Suspense>
        )}
      />
      <Route
        path="/auth/check-email"
        component={() => (
          <Suspense fallback={<Loader />}>
            <CheckYourEmailPage />
          </Suspense>
        )}
      />
      <Route
        path="/email-verification"
        component={() => (
          <Suspense fallback={<Loader />}>
            <EmailVerificationPage />
          </Suspense>
        )}
      />
      <Route
        path="/auth/reset-password-confirm"
        component={() => (
          <Suspense fallback={<Loader />}>
            <ResetPasswordConfirmPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/wix/pricing"
        component={() => (
          <Suspense fallback={<Loader />}>
            <WixPricingPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path={`/new-event/:siteId`}
        render={(props) => (
          <Suspense fallback={<Loader />}>
            <CreateEventPublicPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path={`/new-event/:siteId/events/:eventId`}
        render={(props) => (
          <Suspense fallback={<Loader />}>
            <CreateEventPublicPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/self-checkin"
        component={() => (
          <Suspense fallback={<Loader />}>
            <SelfCheckinKioskPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/attendee-dashboard/ticket/:cartId/order-frame"
        component={() => (
          <Suspense fallback={<Loader />}>
            <AttendeeTicketDetailsPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/accept-invitation"
        component={() => (
          <Suspense fallback={<Loader />}>
            <AcceptInvitationPage />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/invitations"
        component={() => (
          <Suspense fallback={<Loader />}>
            <InvitationsPage />
          </Suspense>
        )}
      />
    </Switch>
  );
};
